(function () {
    'use strict';

    //used by template cache gulp build task
    angular.module('templates', []);

    angular.module('app', [
            'ui.router',
            'ngResource',
            'ngMessages',
            'ui.bootstrap',
            'angular-loading-bar',
            'restangular',
            'LocalStorageModule',
            'toastr',
            'templates',
            'ngSanitize',
            'ngFileUpload',
            'ngTagsInput',
            'checklist-model'
        ])
        .value('appData', $.parseJSON($('#application-data').html()))
        .run([
            '$rootScope',
            '$state',
            'appData',
            'Restangular',
            '$uibModalStack',
            '$window',
            '$stateParams',
            'authService',
            'trackingService',
            function ($rootScope, $state, appData, restangular, $uibModalStack, $window, $stateParams, authService, trackingService) {

                authService.initialize();
                $rootScope.$state = $state;
                restangular.setBaseUrl(appData.applicationRoot + 'api');

                $rootScope.unauthenticated = true;

                $rootScope.$on('$stateChangeSuccess', function () {
                    $uibModalStack.dismissAll();
                });

                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
                    if (toState.name === 'login') return;
                    $rootScope.unauthenticated = !authService.authentication.isAuth;;

                    var requiresAuth = toState.data && toState.data.requireLogin;
                    //check if url requires authentication
                    if (requiresAuth && authService.authentication.isAuth === false) {
                        event.preventDefault();
                        $rootScope.redirectUrl = $state.href(toState.name, toParams);
                        $state.go('login');
                        return;
                    }

                    //check if route requires a specific role
                    var requiredRole = toState.data && toState.data.allowed;
                    if (requiredRole && requiredRole !== authService.authentication.role) {
                        event.preventDefault();
                        $state.go('home');
                        return;
                    }
                });


                $rootScope.$on('$stateChangeSuccess', function () {
                    $window.scrollTo(0, 0);
                });

            }
        ]);

})();